import LegalLayout from "./LegalLayout";
import SeoHead from "@/components/SeoHead";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="May 2, 2026">
      <SeoHead title="Terms & Conditions" />
      <p>
        These Terms & Conditions ("Terms") govern your access to and use of StoreSEO AI (the
        "Service"), operated by <strong>Storeseoai Team</strong> ("we", "us", "our"), based in Nepal.
        By creating an account or using the Service, you agree to be bound by these Terms.
      </p>

      <h2>1. The Service</h2>
      <p>
        StoreSEO AI is an AI-powered tool that generates SEO-optimized titles, descriptions,
        keywords, and tags for e-commerce product listings. Features available depend on your
        selected plan.
      </p>

      <h2>2. Account & Eligibility</h2>
      <ul>
        <li>You must be of legal age in your jurisdiction, or have authority to bind the organization you represent.</li>
        <li>You are responsible for keeping your account credentials confidential and for all activity under your account.</li>
        <li>You must provide accurate information and keep it up to date.</li>
      </ul>

      <h2>3. Acceptable Use</h2>
      <p>You must not misuse the Service. You will not:</p>
      <ul>
        <li>Use the Service for unlawful, fraudulent, or deceptive purposes, including spam.</li>
        <li>Infringe intellectual property or other rights of third parties.</li>
        <li>Interfere with security, including introducing malware, probing, or scraping.</li>
        <li>Generate illegal content, hate speech, deepfakes, malware, or attempt to jailbreak the underlying AI models.</li>
      </ul>

      <h2>4. AI-Generated Content</h2>
      <ul>
        <li>You are responsible for the prompts and inputs you submit, for verifying the accuracy of outputs, and for ensuring you have the rights to any content you input.</li>
        <li>Outputs may be inaccurate or incomplete. You are responsible for how you use them and should not rely on them as professional, legal, or regulated advice without independent review.</li>
        <li>We may remove, restrict, refuse, or filter content and outputs, and suspend accounts that repeatedly produce infringing or prohibited material.</li>
        <li>If you believe content generated through the Service infringes your rights, contact us at <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a> with a takedown request.</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>
        We retain all rights, title, and interest in the Service, including software, documentation,
        and branding. We grant you a limited, non-exclusive, non-transferable right to use the
        Service within your selected plan. You may not reverse engineer, resell, redistribute, or
        circumvent technical limitations.
      </p>

      <h2>6. Payments, Subscriptions & Refunds</h2>
      <p>
        Our order process is conducted by our online reseller <strong>Paddle.com</strong>.
        Paddle.com is the Merchant of Record for all our orders. Paddle provides all customer
        service inquiries and handles returns. Payment, billing, taxes, cancellations, and refunds
        are handled by Paddle and are governed by the{" "}
        <a href="https://www.paddle.com/legal/checkout-buyer-terms" target="_blank" rel="noreferrer">
          Paddle Buyer Terms
        </a>
        . See our <a href="/refund-policy">Refund Policy</a> for refund details.
      </p>

      <h2>7. Service Availability</h2>
      <p>
        We do not guarantee that the Service will be uninterrupted or error-free. To the fullest
        extent permitted by law, we disclaim all implied warranties, including merchantability and
        fitness for a particular purpose.
      </p>

      <h2>8. Suspension & Termination</h2>
      <p>We may suspend or terminate your access for:</p>
      <ul>
        <li>Material breach of these Terms;</li>
        <li>Non-payment;</li>
        <li>Security or fraud risk;</li>
        <li>Repeated or serious policy violations.</li>
      </ul>
      <p>On termination, your access ends. You may request export of your data within 30 days of termination, after which it may be deleted.</p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, our aggregate liability for any claim arising from
        the Service is limited to the fees you paid us in the 12 months prior to the event giving
        rise to the claim. We are not liable for indirect, consequential, or special damages,
        including loss of profits, data, or goodwill. Nothing limits liability for fraud, death, or
        personal injury where such limitation is prohibited by law.
      </p>

      <h2>10. Indemnity</h2>
      <p>You agree to indemnify us against claims arising from your content, your unlawful use of the Service, or your breach of these Terms.</p>

      <h2>11. Governing Law</h2>
      <p>These Terms are governed by the laws of Nepal. Disputes shall be subject to the exclusive jurisdiction of the courts of Nepal.</p>

      <h2>12. Changes & Assignment</h2>
      <p>
        We may update these Terms from time to time. Continued use of the Service after changes
        constitutes acceptance. You may not assign these Terms without our consent; we may assign
        them in connection with a merger, acquisition, or sale of assets.
      </p>

      <h2>13. Contact</h2>
      <p>For questions about these Terms, contact <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a>.</p>
    </LegalLayout>
  );
}
